"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_1 = require("react");
const Menu_1 = __importDefault(require("@mui/material/Menu"));
const ArrowDropDown_1 = __importDefault(require("@mui/icons-material/ArrowDropDown"));
const NestedMenuItem_1 = __importDefault(require("./NestedMenuItem"));
const IconMenuItem_1 = __importDefault(require("./IconMenuItem"));
const styles_1 = require("./styles");
const nestedMenuItemsFromObject = ({ menuItemsData, isOpen, handleClose }) => menuItemsData.map((item) => {
    const { leftIcon, rightIcon, label, items, callback, sx, disabled = false } = item;
    if (items && items.length > 0) {
        // Recurse deeper
        return (<NestedMenuItem_1.default key={label} leftIcon={leftIcon} rightIcon={rightIcon} label={label} parentMenuOpen={isOpen} 
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore: TODO: fix later
        sx={sx} disabled={disabled}>
        {/* Call this function to nest more items */}
        {nestedMenuItemsFromObject({
                menuItemsData: items,
                isOpen,
                handleClose,
            })}
      </NestedMenuItem_1.default>);
    }
    // No children elements, return MenuItem
    return (<IconMenuItem_1.default key={label} leftIcon={leftIcon} rightIcon={rightIcon} label={label} 
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore: TODO: fix later
    onClick={() => {
            handleClose();
            if (callback) {
                callback();
            }
        }} sx={sx} disabled={disabled}/>);
});
const NestedDropdown = (0, react_1.forwardRef)((props, ref) => {
    var _a, _b;
    const [anchorEl, setAnchorEl] = (0, react_1.useState)(null);
    const open = Boolean(anchorEl);
    const { menuItemsData: data, onClick, ButtonProps, MenuProps } = props, rest = __rest(props, ["menuItemsData", "onClick", "ButtonProps", "MenuProps"]);
    const handleClick = (e) => {
        setAnchorEl(e.currentTarget);
        if (onClick) {
            onClick(e);
        }
    };
    const handleClose = () => {
        // The Menu's root gets aria-hidden while closing; if the item that triggered the
        // close (or the parent trigger of a nested submenu) still has focus, the browser
        // blocks it since a focused element can't sit inside an aria-hidden ancestor.
        if (document.activeElement instanceof HTMLElement) {
            document.activeElement.blur();
        }
        setAnchorEl(null);
    };
    const menuItems = nestedMenuItemsFromObject({
        menuItemsData: (_a = data === null || data === void 0 ? void 0 : data.items) !== null && _a !== void 0 ? _a : [],
        isOpen: open,
        handleClose,
    });
    return (<div ref={ref} {...rest}>
      <styles_1.StyledButton onClick={handleClick} endIcon={<ArrowDropDown_1.default />} disableElevation disableFocusRipple disableRipple {...ButtonProps}>
        {(_b = data === null || data === void 0 ? void 0 : data.label) !== null && _b !== void 0 ? _b : 'Menu'}
      </styles_1.StyledButton>
      <Menu_1.default anchorEl={anchorEl} open={open} onClose={handleClose} PaperProps={{ sx: { minWidth: '172px' } }} {...MenuProps}>
        {menuItems}
      </Menu_1.default>
    </div>);
});
exports.default = NestedDropdown;
